import React, { useState, useEffect, useContext, useCallback } from 'react';

import { useNavigate, useLocation } from 'react-router-dom'; // Import useNavigate and useLocation for navigation

import axios from 'axios';

import { FaArrowLeft, FaTrash, FaUsers, FaMapMarkerAlt, FaCheckCircle, FaBuilding, FaStore, FaSave, FaExclamationTriangle, FaEdit, FaTimes, FaPlus, FaList, FaImage, FaDollarSign, FaCog } from 'react-icons/fa';
import './CreateCustomerPage.css'; // Import FaArrowLeft for back button and FaTrash for delete

import { UserContext } from '../../Context/UserContext';

const CreateVariant = () => {

  const [variantName, setVariantName] = useState('');

  const [types, setTypes] = useState([]);
  const [showAssignmentModal, setShowAssignmentModal] = useState(false);

  const [newType, setNewType] = useState('');

  const [prices, setPrices] = useState({});

  const [images, setImages] = useState({});

  const [activeSection, setActiveSection] = useState(null);

  const [variants, setVariants] = useState([]);

  const [editingVariantId, setEditingVariantId] = useState(null);

  const [showList, setShowList] = useState(false);

  const [warning, setWarning] = useState(null);

  const [loading, setLoading] = useState(true); // NEW: Loading state for initial fetch

  const [error, setError] = useState(null); // NEW: Error state for network/config issues

  const [showConfirm, setShowConfirm] = useState(false); // NEW: Confirmation dialog state

  const [confirmVariant, setConfirmVariant] = useState(null); // NEW: Variant to confirm delete

  const navigate = useNavigate(); // Initialize useNavigate hook

  const location = useLocation(); // Initialize useLocation hook

  const [baseUrl, setBaseUrl] = useState(""); // NEW: baseUrl state like in AdminPage



  // Permission State

  const [canWrite, setCanWrite] = useState(false);

  const [canDelete, setCanDelete] = useState(false);



  // Multi-tenant State

  const [isCompanyAdmin, setIsCompanyAdmin] = useState(false);

  const [isGroupAdmin, setIsGroupAdmin] = useState(false);

  const [selectedCompanies, setSelectedCompanies] = useState([]);

  const [companyOptions, setCompanyOptions] = useState([]);

  const [availableBranches, setAvailableBranches] = useState([]);

  const [selectedBranchNames, setSelectedBranchNames] = useState([]);

  const { getHeaders } = useContext(UserContext);



  const fetchCompanies = useCallback(async (apiUrl) => {

    try {

      const userStr = localStorage.getItem('user');

      const userObj = userStr ? JSON.parse(userStr) : {};

      

      if (userObj.role === 'group_admin' && userObj.companies && userObj.companies.length > 0) {

        setCompanyOptions(userObj.companies);

        return;

      }



      const headers = getHeaders();

      const response = await axios.get(`${apiUrl}/api/company-details`, { headers });

      const details = response.data.companyDetails || [];

      const names = details.map(d => d.restaurantName).filter(n => n);

      setCompanyOptions([...new Set(names)]);

    } catch (err) {

      console.error('Error fetching companies:', err);

    }

  }, [getHeaders]);



  const fetchBranches = useCallback(async (apiUrl) => {

    try {

      const headers = getHeaders();

      const response = await axios.get(`${apiUrl}/api/branches`, { headers });

      const branchData = response.data.map(b => typeof b === 'string' ? b : (b.branch_name || b.branch || b.name));

      setAvailableBranches(branchData);

    } catch (error) {

      console.error('Error fetching branches:', error);

    }

  }, [getHeaders]);



  useEffect(() => {

    const fetchPermissions = async () => {

      try {

        const userStr = localStorage.getItem('user');

        if (userStr) {

          const user = JSON.parse(userStr);

          const role = user.role;

          

          // Role Detection
          const branch = user.branch_name || user.branch || "";
          const roleNorm = (role || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
          const isGroup = roleNorm === 'groupadmin' || roleNorm === 'superadmin' || user.role === 'Super Admin';
          const isCA = roleNorm === 'companyadmin' || roleNorm === 'admin' || roleNorm === 'manager';
          
          setIsGroupAdmin(isGroup);
          setIsCompanyAdmin(isCA || isGroup);



          const activeContext = localStorage.getItem('active_company');
          if (activeContext && activeContext !== 'All') {
            setSelectedCompanies([activeContext]);
          } else if (user.company_name) {
            setSelectedCompanies([user.company_name]);
          }

          if (isGroup || isCA) {
            fetchCompanies(baseUrl || "");
          }

          fetchBranches(baseUrl || "");



          if (role) {

            const url = baseUrl ? `${baseUrl}/api/role-permissions?role=${role}` : `/api/role-permissions?role=${role}`;

            const response = await axios.get(url);

            const perms = response.data.permissions || [];

            const pagePerm = perms.find(p => p.pageId === 'create_variant');

            if (pagePerm) {

              setCanWrite(pagePerm.canWrite === true);

              setCanDelete(pagePerm.canDelete === true);

            }

            // Super admins / admins bypass

            if (role === 'company_admin' || role === 'admin' || role === 'group_admin') {

              setCanWrite(true);

              setCanDelete(true);

            }

          }

        }

      } catch (error) {

        console.error("Error fetching permissions:", error);

      }

    };

    fetchPermissions();

  }, [baseUrl, fetchCompanies, fetchBranches]);



  // NEW: Fetch config to determine baseUrl (same logic as AdminPage)

  useEffect(() => {

    const fetchConfig = async () => {

      let currentBaseUrl = "";

      try {

        const response = await axios.get("/api/network_info");

        const { config: appConfig } = response.data;

        if (appConfig.mode === "client") {

          currentBaseUrl = `http://${appConfig.server_ip}:6034`;

          setBaseUrl(currentBaseUrl);

        } else {

          setBaseUrl("");

        }

      } catch (error) {

        console.error("Failed to fetch config:", error);

        setBaseUrl("");

        setError("Failed to connect to server. Using local mode.");

      } finally {

        setLoading(false);

        // If not loading, fetch variants after config

        if (!currentBaseUrl) {

          fetchVariants("");

        }

      }

    };

    fetchConfig();

  }, []);

  // Clear warning after 3 seconds

  useEffect(() => {

    if (warning) {

      const timer = setTimeout(() => setWarning(null), 3000);

      return () => clearTimeout(timer);

    }

  }, [warning]);

  // UPDATED: Fetch all variants for the list (use baseUrl)

  const fetchVariants = async (currentBaseUrl) => {

    try {

      const apiUrl = currentBaseUrl || '';

      const response = await axios.get(`${apiUrl}/api/variants`);

      setVariants(response.data);

    } catch (error) {

      setWarning({ type: 'error', message: 'Failed to fetch variants' });

      console.error('Error fetching variants:', error);

    }

  };

  // UPDATED: Fetch a specific variant for editing (use baseUrl)

  const fetchVariant = async (id, currentBaseUrl) => {

    try {

      const apiUrl = currentBaseUrl || '';

      const response = await axios.get(`${apiUrl}/api/variants/${id}`);

      const variant = response.data;

      setVariantName(variant.heading);

      setTypes(variant.subheadings.map((sub) => sub.name));

      setPrices(

        variant.subheadings.reduce((acc, sub) => ({

          ...acc,

          [sub.name]: sub.price || '',

        }), {})

      );

      setImages(

        variant.subheadings.reduce((acc, sub) => ({

          ...acc,

          [sub.name]: sub.image || '',

        }), {})

      );

      setActiveSection(variant.activeSection || 'price');

      setEditingVariantId(id);

      setSelectedCompanies(variant.company_names || (variant.company_name ? [variant.company_name] : []));

      setSelectedBranchNames(variant.branch_names || (variant.branch_name ? [variant.branch_name] : []));

      setShowList(false);

    } catch (error) {

      setWarning({ type: 'error', message: 'Failed to fetch variant' });

      console.error('Error fetching variant:', error);

    }

  };

  // UPDATED: Handle delete variant - Show confirmation dialog instead of window.confirm

  const handleDeleteVariant = (id, heading) => {

    if (!canDelete) {

      setWarning({ type: 'error', message: 'You do not have permission to delete variants.' });

      return;

    }

    setConfirmVariant({ id, heading });

    setShowConfirm(true);

  };

  // NEW: Confirm delete action

  const confirmDelete = async () => {

    if (!confirmVariant) return;

    try {

      const apiUrl = baseUrl || '';

      await axios.delete(`${apiUrl}/api/variants/${confirmVariant.id}`);

      setWarning({ type: 'success', message: 'Variant deleted successfully' });

      // If editing this variant, reset form

      if (editingVariantId === confirmVariant.id) {

        resetForm();

      }

      fetchVariants(baseUrl); // Re-fetch after delete

    } catch (error) {

      const errorMsg = error.response?.data?.error || 'Failed to delete variant';

      setWarning({ type: 'error', message: errorMsg });

      console.error('Error deleting variant:', error);

    } finally {

      setShowConfirm(false);

      setConfirmVariant(null);

    }

  };

  // NEW: Cancel delete

  const cancelDelete = () => {

    setShowConfirm(false);

    setConfirmVariant(null);

  };

  // NEW: Helper to reset form

  const resetForm = () => {

    setVariantName('');

    setTypes([]);

    setNewType('');

    setPrices({});

    setImages({});

    setActiveSection(null);

    setEditingVariantId(null);

    const activeContext = localStorage.getItem('active_company');

    if (activeContext !== 'All') {

      const userStr = localStorage.getItem('user');

      const user = userStr ? JSON.parse(userStr) : {};

      setSelectedCompanies([activeContext || user.company_name || ""]);

    } else {

      setSelectedCompanies([]);

    }

    setSelectedBranchNames([]);

  };

  // UPDATED: Handle saving variant (use baseUrl)

  const handleSave = async () => {

    try {

      if (!canWrite) {

        setWarning({ type: 'error', message: 'You do not have permission to save variants.' });

        return;

      }

      if (!variantName.trim()) {

        setWarning({ type: 'error', message: 'Variant name is required' });

        return;

      }

      if (types.length === 0) {

        setWarning({ type: 'error', message: 'At least one type is required' });

        return;

      }

      const variantData = {

        heading: variantName,

        subheadings: types.map((type) => {

          const subheading = { name: type };

          if (activeSection === 'price' || activeSection === 'priceAndImage') {

            subheading.price = prices[type] ? parseFloat(prices[type]) : null;

          }

          if (activeSection === 'priceAndImage') {

            subheading.image = images[type] || null;

          }

          if (activeSection === 'dropdown') {

            subheading.dropdown = true;

          }

          return subheading;

        }),

        activeSection,

        company_names: selectedCompanies,

        branch_names: selectedBranchNames,

        company_name: selectedCompanies[0] || "",

        branch_name: selectedBranchNames[0] || ""

      };

      const apiUrl = baseUrl || '';

      if (editingVariantId) {

        await axios.put(`${apiUrl}/api/variants/${editingVariantId}`, variantData);

        setWarning({ type: 'success', message: 'Variant updated successfully' });

      } else {

        await axios.delete(`${apiUrl}/api/variants/heading/${variantName}`);

        await axios.post(`${apiUrl}/api/variants`, variantData);

        setWarning({ type: 'success', message: 'Variant saved successfully' });

      }

      if (location.state?.returnPath) {

        setTimeout(() => {

          navigate(location.state.returnPath, {

            state: { formData: location.state.formData },

          });

        }, 1000);

      } else {

        resetForm();

        fetchVariants(baseUrl); // Re-fetch after save

      }

    } catch (error) {

      const errorMsg = error.response?.data?.error || 'Failed to save variant';

      setWarning({ type: 'error', message: errorMsg });

      console.error('Error saving variant:', error);

    }

  };



  const toggleCompanySelection = (comp) => {

    setSelectedCompanies(prev => 

      prev.includes(comp) ? prev.filter(c => c !== comp) : [...prev, comp]

    );

  };



  const toggleBranchSelection = (branchName) => {

    setSelectedBranchNames(prev => 

      prev.includes(branchName) ? prev.filter(b => b !== branchName) : [...prev, branchName]

    );

  };

  const handleRemoveType = (typeToRemove) => {
    setTypes(types.filter(t => t !== typeToRemove));
    const newPrices = { ...prices };
    delete newPrices[typeToRemove];
    setPrices(newPrices);
    const newImages = { ...images };
    delete newImages[typeToRemove];
    setImages(newImages);
  };

  const handleEditType = (typeToEdit) => {
    setNewType(typeToEdit);
    handleRemoveType(typeToEdit);
  };

  // Handle adding a new type

  const handleAddType = () => {

    if (newType.trim() && !types.includes(newType.trim())) {

      setTypes([...types, newType.trim()]);

      setNewType('');

    }

  };

  // Handle price input for a specific type

  const handlePriceChange = (type, value) => {

    setPrices({ ...prices, [type]: value });

  };

  // Handle image upload for a specific type

  const handleImageUpload = (type, event) => {

    const file = event.target.files[0];

    if (file) {

      const imageUrl = URL.createObjectURL(file);

      setImages({ ...images, [type]: imageUrl });

    }

  };

  // Render price fields
  const renderPriceFields = () => {
    return types.map((type) => (
      <div key={type} className="form-group" style={{ marginBottom: '15px' }}>
        <label>{`${type} Price`}</label>
        <input
          type="number"
          value={prices[type] || ''}
          onChange={(e) => handlePriceChange(type, e.target.value)}
          className="form-control"
          placeholder="Enter price"
        />
      </div>
    ));
  };
  // Render price and image fields together
  const renderPriceAndImageFields = () => {
    return types.map((type) => (
      <div key={type} style={{ marginBottom: '25px', padding: '15px', border: '1px solid #e1e8ed', borderRadius: '10px', background: '#f8fafc' }}>
        <h4 style={{ margin: '0 0 15px 0', color: '#2c3e50', fontSize: '15px' }}>{type}</h4>
        <div className="form-group">
          <label>{`${type} Price`}</label>
          <input
            type="number"
            value={prices[type] || ''}
            onChange={(e) => handlePriceChange(type, e.target.value)}
            className="form-control"
            placeholder="Enter price"
          />
        </div>
        <div className="form-group">
          <label>{`${type} Image`}</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleImageUpload(type, e)}
            className="form-control"
          />
          {images[type] && (
            <img
              src={images[type]}
              alt={`${type} preview`}
              style={{ maxWidth: '150px', height: 'auto', borderRadius: '8px', marginTop: '10px', border: '1px solid #dee2e6' }}
            />
          )}
        </div>
      </div>
    ));
  };
  // Render dropdown
  const renderDropdown = () => {
    return (
      <div className="form-group" style={{ marginBottom: '15px' }}>
        <label>Select Type</label>
        <select className="form-control">
          {types.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
      </div>
    );
  };
  // Handle button clicks to toggle sections

  const handleShowSection = (section) => {

    setActiveSection(section);

  };

  // UPDATED: Toggle variant list visibility (fetch with baseUrl)

  const handleShowList = () => {

    setShowList(!showList);

    if (!showList) fetchVariants(baseUrl);

  };

  // Handle back navigation

  const handleBack = () => {

    if (location.state?.returnPath) {

      navigate(location.state.returnPath, {

        state: { formData: location.state.formData },

        replace: true,

      });

    } else {

      navigate('/admin'); // Adjust the path as needed (e.g., '/dashboard')

    }

  };

  // UPDATED: If loading, show loader; if error, show error
  if (loading) {
    return (
      <div className="create-customer-container main-customer-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <h2 style={{ color: '#3498db' }}>Loading configuration...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="create-customer-container main-customer-page">
        <div className="customer-header-section">
          <div className="header-left">
            <button onClick={handleBack} className="header-back-btn">
              <FaArrowLeft /> Back
            </button>
          </div>
        </div>
        <div className="customer-scroll-body">
          <div style={{ color: '#c0392b', textAlign: 'center', padding: '20px', background: '#ffebee', borderRadius: '10px' }}>
            {error}
          </div>
        </div>
      </div>
    );
  }


  const isSpecificBranchActive = (localStorage.getItem('branch_name') || '').toLowerCase() !== 'all branches' && (localStorage.getItem('branch_name') || '') !== '';
  const showCompanyAssign = (isGroupAdmin || isCompanyAdmin) && companyOptions.length > 0;
  const showBranchAssign = (isGroupAdmin || isCompanyAdmin) && !isSpecificBranchActive && availableBranches.length > 0;

  const handleSaveClick = () => {
    // Validate first before opening modal or saving
    if (!variantName.trim()) {
      setWarning({ type: 'error', message: 'Variant name is required' });
      return;
    }
    if (types.length === 0) {
      setWarning({ type: 'error', message: 'At least one type is required' });
      return;
    }
    if (showCompanyAssign || showBranchAssign) {
      setShowAssignmentModal(true);
    } else {
      handleSave();
    }
  };

  return (
    <div className="create-customer-container main-customer-page">
      <div className="customer-header-section">
        <div className="header-left">
          <button onClick={handleBack} className="header-back-btn">
            <FaArrowLeft /> Back to Admin
          </button>
        </div>
        <div className="header-center">
          <h2 className="header-title">Create Variant</h2>
        </div>
        <div className="header-right">
          <div className="header-actions">
            {showCompanyAssign && (
              <button
                type="button"
                onClick={() => setShowAssignmentModal(true)}
                style={{
                  background: '#eff2f9',
                  color: '#604BE8',
                  border: '1.5px solid #C3CDE4',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '0 20px',
                  height: '44px',
                  minWidth: '120px',
                  borderRadius: '12px',
                  fontWeight: '700',
                  fontSize: '14px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 2px 8px rgba(96,75,232,0.10)'
                }}
              >
                <FaUsers /> Company
              </button>
            )}
            {showBranchAssign && (
              <button
                type="button"
                onClick={() => setShowAssignmentModal(true)}
                style={{
                  background: '#fff8f0',
                  color: '#FF9F04',
                  border: '1.5px solid #FDD36D',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '0 20px',
                  height: '44px',
                  minWidth: '120px',
                  borderRadius: '12px',
                  fontWeight: '700',
                  fontSize: '14px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 2px 8px rgba(255,159,4,0.10)'
                }}
              >
                <FaMapMarkerAlt /> Branches
              </button>
            )}
            {(isGroupAdmin || isCompanyAdmin) && (
              <button
                type="button"
                onClick={() => setShowAssignmentModal(true)}
                style={{
                  background: 'linear-gradient(135deg, #11c87a 0%, #0db369 100%)',
                  color: '#fff',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '0 20px',
                  height: '44px',
                  minWidth: '130px',
                  borderRadius: '12px',
                  fontWeight: '700',
                  fontSize: '14px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 4px 12px rgba(17,200,122,0.25)'
                }}
              >
                <FaCog /> Customize
              </button>
            )}
            <button className="save-btn" onClick={handleSaveClick} disabled={!canWrite}>
              <FaSave /> {editingVariantId ? 'Update Variant' : 'Save Variant'}
            </button>
          </div>
        </div>
      </div>
      <div className="header-divider"></div>

      <div className="customer-scroll-body">
        <div className="form-sections-wrapper" style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
          
          <div className="form-section-card theme-blue" style={{ marginBottom: '20px' }}>
            <div className="section-header">
              <div className="section-icon"><FaEdit /></div>
              <h3 className="section-title">Variant Details</h3>
            </div>
            
            <div className="form-grid" style={{ padding: '20px' }}>
              <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                <label>Variant Name <span className="required">*</span></label>
                <input
                  type="text"
                  value={variantName}
                  onChange={(e) => setVariantName(e.target.value)}
                  className="form-control"
                  placeholder="e.g., Size"
                />
              </div>

              <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                <label>Add Type <span className="required">*</span></label>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <input
                    type="text"
                    value={newType}
                    onChange={(e) => setNewType(e.target.value)}
                    className="form-control"
                    placeholder="e.g., Small, Medium, Large"
                  />
                  <button onClick={handleAddType} className="add-btn">
                    <FaPlus style={{ marginRight: '5px' }} /> Add Type
                  </button>
                </div>
              </div>
            </div>

            {/* Display Added Types */}
            {types.length > 0 && (
              <div style={{ padding: '0 20px 20px 20px' }}>
                <h4 style={{ color: '#2c3e50', fontSize: '15px', marginBottom: '10px' }}>Added Types:</h4>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {types.map((type) => (
                    <span key={type} style={{ display: 'flex', alignItems: 'center', background: '#3498db', color: 'white', padding: '6px 12px', borderRadius: '20px', fontSize: '14px', fontWeight: 'bold' }}>
                      <span style={{ marginRight: '8px' }}>{type}</span>
                      <FaTimes style={{ cursor: 'pointer', background: 'rgba(255,255,255,0.3)', borderRadius: '50%', padding: '2px' }} onClick={() => handleRemoveType(type)} title="Remove type" />
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>

          

          {/* Assignment Modal - matches CreateCustomerPage design */}
          {showAssignmentModal && (
            <div className="add-modal-overlay">
              <div className="add-modal" style={{ maxWidth: '600px' }}>
                <div className="modal-header">
                  <span>Assignment Settings</span>
                  <button className="close-modal-btn" onClick={() => setShowAssignmentModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px' }}>
                    <FaTimes />
                  </button>
                </div>
                <div className="modal-body" style={{ marginTop: '20px' }}>
                  {showCompanyAssign && (
                    <div className="assignment-card" style={{ marginBottom: '20px' }}>
                      <h4 style={{ color: '#604BE8' }}><FaUsers /> Select Company *</h4>
                      <div className="checkbox-group" style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                        {companyOptions.map((comp, idx) => (
                          <label key={idx} className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 18px', background: '#eff2f9', borderRadius: '12px', border: `1.5px solid ${selectedCompanies.includes(comp) ? '#604BE8' : '#C3CDE4'}`, cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>
                            <input
                              type="checkbox"
                              checked={selectedCompanies.includes(comp)}
                              onChange={() => toggleCompanySelection(comp)}
                              style={{ width: '18px', height: '18px', accentColor: '#604BE8' }}
                            />
                            {comp}
                          </label>
                        ))}
                      </div>
                    </div>
                  )}
                  {showBranchAssign && availableBranches.length > 0 && (
                    <div className="assignment-card">
                      <h4 style={{ color: '#06D6A0' }}><FaMapMarkerAlt /> Select Branch</h4>
                      <div className="checkbox-group" style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                        {availableBranches.map((branch, idx) => (
                          <label key={idx} className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 18px', background: '#ecfdf5', borderRadius: '12px', border: `1.5px solid ${selectedBranchNames.includes(branch) ? '#06D6A0' : '#d1fae5'}`, cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>
                            <input
                              type="checkbox"
                              checked={selectedBranchNames.includes(branch)}
                              onChange={() => toggleBranchSelection(branch)}
                              style={{ width: '18px', height: '18px', accentColor: '#06D6A0' }}
                            />
                            {branch}
                          </label>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <div className="modal-footer" style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                  <button
                    onClick={() => setShowAssignmentModal(false)}
                    style={{ padding: '10px 22px', borderRadius: '10px', background: '#f1f5f9', color: '#64748b', border: '1px solid #e2e8f0', cursor: 'pointer', fontWeight: '700', fontSize: '14px' }}
                  >
                    Cancel
                  </button>
                  <button
                    className="save-btn"
                    onClick={() => { setShowAssignmentModal(false); handleSave(); }}
                  >
                    Confirm &amp; Save
                  </button>
                </div>
              </div>
            </div>
          )}


          <div className="form-section-card theme-blue" style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', gap: '15px', padding: '20px 20px 0 20px', flexWrap: 'wrap' }}>
               <button onClick={() => handleShowSection('price')} className="tab-btn" style={{ flex: 1, backgroundColor: activeSection === 'price' ? '#3498db' : '#95a5a6' }}>
                  <FaDollarSign style={{ marginRight: '5px' }} /> Pricing
               </button>
               <button onClick={() => handleShowSection('priceAndImage')} className="tab-btn" style={{ flex: 1, backgroundColor: activeSection === 'priceAndImage' ? '#2ecc71' : '#95a5a6' }}>
                  <FaImage style={{ marginRight: '5px' }} /> Image
               </button>
               <button onClick={() => handleShowSection('dropdown')} className="tab-btn" style={{ flex: 1, backgroundColor: activeSection === 'dropdown' ? '#f39c12' : '#95a5a6' }}>
                  <FaList style={{ marginRight: '5px' }} /> Dropdown
               </button>
               <button onClick={handleShowList} className="tab-btn" style={{ flex: 1, backgroundColor: showList ? '#7f8c8d' : '#34495e' }}>
                  {showList ? 'Hide List' : 'List Variants'}
               </button>
            </div>
            
            <div style={{ padding: '20px' }}>
              {types.length > 0 && activeSection === 'price' && (
                <div style={{ padding: '20px', border: '1px solid #e1e8ed', borderRadius: '12px', background: '#f8fafc' }}>
                  {renderPriceFields()}
                </div>
              )}
              {types.length > 0 && activeSection === 'priceAndImage' && (
                <div style={{ padding: '20px', border: '1px solid #e1e8ed', borderRadius: '12px', background: '#f8fafc' }}>
                  {renderPriceAndImageFields()}
                </div>
              )}
              {types.length > 0 && activeSection === 'dropdown' && (
                <div style={{ padding: '20px', border: '1px solid #e1e8ed', borderRadius: '12px', background: '#f8fafc' }}>
                  {renderDropdown()}
                </div>
              )}
            </div>
          </div>

          {/* Variant List Table */}
          {showList && (
            <div className="form-section-card theme-green" style={{ marginBottom: '20px' }}>
              <div className="section-header">
                <div className="section-icon"><FaList /></div>
                <h3 className="section-title">Variants</h3>
              </div>
              <div className="premium-card">
                <table className="premium-table">
                  <thead>
                    <tr>
                      <th>Heading</th>
                      <th style={{ textAlign: 'right' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {variants.length === 0 ? (
                      <tr>
                        <td colSpan="2" style={{ textAlign: 'center', padding: '20px', color: '#7f8c8d' }}>
                          No variants found.
                        </td>
                      </tr>
                    ) : (
                      variants.map((variant) => (
                        <tr key={variant._id}>
                          <td style={{ fontWeight: '600' }}>{variant.heading}</td>
                          <td className="actions-cell" style={{ textAlign: 'right' }}>
                            <button
                              className="action-btn action-btn-edit"
                              onClick={() => fetchVariant(variant._id, baseUrl)}
                              style={{ marginRight: '10px' }}
                              title="Edit Variant"
                            >
                              <FaEdit />
                            </button>
                            <button
                              className="action-btn action-btn-delete"
                              onClick={() => handleDeleteVariant(variant._id, variant.heading)}
                              title="Delete Variant"
                            >
                              <FaTrash />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>

      {warning && (
        <div className="warning-modal-overlay">
          <div className="warning-modal" style={{ borderTop: warning.type === 'success' ? '4px solid #06D6A0' : '4px solid #f39c12' }}>
            <div className="warning-icon-wrapper" style={{ background: warning.type === 'success' ? '#e6fcf5' : '#fef4e6', color: warning.type === 'success' ? '#06D6A0' : '#f39c12' }}>
              {warning.type === 'success' ? <FaCheckCircle /> : <FaExclamationTriangle />}
            </div>
            <h3>{warning.type === 'success' ? 'Success' : 'Notice'}</h3>
            <p>{warning.message}</p>
            <div className="warning-modal-actions">
              <button 
                className="confirm-delete-btn" 
                onClick={() => setWarning(null)}
                style={{ backgroundColor: warning.type === 'success' ? '#06D6A0' : '#f39c12', color: 'white', width: '100%', margin: '0' }}
              >
                {warning.type === 'success' ? 'Done' : 'OK'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Dialog */}
      {showConfirm && confirmVariant && (
        <div className="warning-modal-overlay">
          <div className="warning-modal" style={{ borderTop: '4px solid #f39c12' }}>
            <div className="warning-icon-wrapper" style={{ background: '#fef4e6', color: '#f39c12' }}>
              <FaExclamationTriangle />
            </div>
            <h3>Delete Variant</h3>
            <p>Are you sure you want to delete the variant "{confirmVariant.heading}"?</p>
            <div className="warning-modal-actions" style={{ display: 'flex', gap: '10px' }}>
              <button className="cancel-delete-btn" onClick={() => setShowConfirm(false)} style={{ flex: 1 }}>
                Cancel
              </button>
              <button className="confirm-delete-btn" onClick={confirmDelete} style={{ flex: 1, margin: 0 }}>
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default CreateVariant;
